import { render } from "./Modules.vue?vue&type=template&id=157561a4&scoped=true"
import script from "./Modules.vue?vue&type=script&lang=js"
export * from "./Modules.vue?vue&type=script&lang=js"

import "./Modules.vue?vue&type=style&index=0&id=157561a4&scoped=true&lang=css"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157561a4"]])

export default __exports__